import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { ButtonBase, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Help, SearchSharp } from '@material-ui/icons';
import {
  PERIOD_SCALE_ENUM,
  DISPLAY_UNIT_ENUM
} from '~/modules/resourcing/common/enums';
import { useRedirectToAssignResource } from '~/modules/resourcing/hooks';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: theme.spacing(0.5, 1),
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    alignItems: 'center',
    borderRadius: theme.spacing(0.75),
    justifyContent: 'space-between'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  noMatchFound: {
    display: 'flex',
    gap: theme.spacing(0.75),
    alignItems: 'center'
  },
  helpIcon: {
    fontSize: theme.spacing(2.5),
    color: theme.palette.text.secondary
  },
  searchIcon: {
    fontSize: theme.spacing(3.25),
    color: theme.palette.text.secondary
  }
}));

export const ResourceRequestMatchItemNoMatches = ({
  resourceRequest,
  scale,
  displayUnit
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const history = useHistory();
  const onAssignResourceAction = useRedirectToAssignResource({
    history,
    resourceRequest,
    isResourcingTab: false,
    scale,
    displayUnit
  });

  const allocateResourceMessage = formatMessage({
    id: 'resourceAllocationItem.allocateResource'
  });

  return (
    <div
      data-qe-id={`${resourceRequest.id}_ResourceRequestMatchItemNoMatches`}
      className={classes.root}
    >
      <div className={classes.textContainer}>
        <ButtonBase
          aria-label={allocateResourceMessage}
          onClick={onAssignResourceAction}
        >
          <Typography variant="body1" color="textPrimary">
            {allocateResourceMessage}
          </Typography>
        </ButtonBase>
        <div className={classes.noMatchFound}>
          <Typography variant="body2" color="error">
            {formatMessage({
              id: 'resourceAllocationItem.noMatchFound2'
            })}
          </Typography>
          <Help className={classes.helpIcon} />
        </div>
      </div>
      <ButtonBase
        aria-label={allocateResourceMessage}
        onClick={onAssignResourceAction}
      >
        <SearchSharp className={classes.searchIcon} />
      </ButtonBase>
    </div>
  );
};

ResourceRequestMatchItemNoMatches.propTypes = {
  resourceRequest: PropTypes.object.isRequired,
  scale: PropTypes.oneOf(Object.values(PERIOD_SCALE_ENUM)),
  displayUnit: PropTypes.oneOf(Object.values(DISPLAY_UNIT_ENUM))
};

export default ResourceRequestMatchItemNoMatches;
